import {Line} from "@react-three/drei";
import {useMemo} from "react";
import type {Dimensions} from "../Scene.tsx";

type GridProps = {
    dimensions: Dimensions;
    color?: string;
    lineWidth?: number;
    active: boolean;
}

export function Grid({dimensions, lineWidth = 1, color = "#666666", active = true}: GridProps) {
    if (!active) return null;

    const {width, height, depth} = dimensions;

    const boxEdges = useMemo(() => {
        const hw = width / 2;
        const hh = height / 2;
        const hwi = hw - 0.005; // inside the boundaries

        // 8 vertices of the box (from z=0 to z=-depth)
        const v0: [number, number, number] = [-hwi, -hh, -depth]; // back bottom left
        const v1: [number, number, number] = [hwi, -hh, -depth];  // back bottom right
        const v2: [number, number, number] = [hwi, hh, -depth];   // back top right
        const v3: [number, number, number] = [-hwi, hh, -depth];  // back top left
        const v4: [number, number, number] = [-hwi, -hh, 0];      // front bottom left
        const v5: [number, number, number] = [hwi, -hh, 0];       // front bottom right
        const v6: [number, number, number] = [hwi, hh, 0];        // front top right
        const v7: [number, number, number] = [-hwi, hh, 0];       // front top left

        // 8 edges (back + connections, no front)
        return [
            // back
            [v0, v1], [v1, v2], [v2, v3], [v3, v0],
            // connections
            [v0, v4], [v1, v5], [v2, v6], [v3, v7]
        ] as [[number, number, number], [number, number, number]][];
    }, [width, height, depth]);

    return (
        <>
            {boxEdges.map((edge, i) => (
                <Line
                    key={i}
                    points={edge}
                    color={color}
                    lineWidth={lineWidth}
                />
            ))}
        </>
    );
}

